import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  EnrollmentStepWrapper,
  EnrollmentStepFooter,
  EnrollmentFormRow,
  EnrollmentFormCol,
  CreditCheckSection,
  InputWithMask,
  InputMaskToggle,
} from "../../styles/Enrollment.styled";
import { Button } from "../../styles/Button.styled";
import { Form, Dropdown, Spinner } from "react-bootstrap";
import { CheckboxItem } from "../../CheckboxItem";
import { FormError } from "../../FormError";
import { confirmEnrollment, saveEnrollment } from "../../../fetch/enrollment";
// import { toast } from 'react-toastify'
import moment, { Moment } from "moment";
import NumberFormat from "react-number-format";
import Datetime from "react-datetime";
import { LoadingRow } from "../../LoadingRow";
import { EnrollmentContext } from "./enrollment";
import {
  CONSTELLATION_UTIL_MAPPING,
  PROMO_CODE,
  REFERER_URL,
} from "../../../config";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import { FormLoading } from "../../FormLoading";
import { Address, EnrollmentFields } from "../../../types";
import { RadioBox } from "./RadioBox";
import { ValidateAddress } from "./validate_address";
import { EnrollmentStepService } from "./StepService";
import { pushToDataLayer } from "../../data";
import { preProcessFile } from "typescript";

interface ServiceTypeOption {
  label: string;
  value: string;
  desc: string;
}
interface Props {
  show: boolean;
  handleBack: Function;
  handleContinue: Function;
  enrollmentId: string;
  dynamicFields: any;
  product: string;
  sign: string;
  specialPro: {
    ssn: any;
    date_of_birth: any;
  };
  handleEnrollId: Function;
  handleSSN: Function;
  handleSetName: Function;
  handleSetEmail: Function;
  handlePayment: Function;
}

interface StatesOption {
  name: string;
  abbr: string;
}

const dynamicFields: any = {
  ext_input: {
    date_of_birth: {
      type: "date",
      label: "Date of Birth",
    },
    premise_type: {
      type: "select",
      label: "Premise Type",
      value: [
        {
          label: "House",
          value: "House",
          desc: "House",
        },
        {
          label: "Apartment",
          value: "Apartment",
          desc: "Apartment",
        },
      ],
    },
  },
  credit_check: {
    ssn: {
      type: "text",
      label: "SSN",
    },
  },
};
export const EnrollmentStepInfo: React.FC<Props> = ({
  show,
  handleBack,
  handleContinue,
  product,
  // dynamicFields,
  specialPro,
  handleEnrollId,
  handleSSN,
  handleSetName,
  handleSetEmail,
  handlePayment,
}) => {
  const { t } = useTranslation("enrollment");
  const {
    serviceAddress,
    promoCode,
    storePromoCode,
    handleSetErrorModalContent,
    utility,
    selectedProduct,
  } = useContext<any>(EnrollmentContext);
  const [inputValue, setInputValue] = useState<any>({
    first_name: { type: "text", value: "" },
    last_name: { type: "text", value: "" },
    email: { type: "text", value: "" },
    email2: { type: "text", value: "" },
    phone: { type: "number", value: "" },
    billing_address: { type: "text", value: "" },
    billing_address2: { type: "text", value: "" },
    billing_city: { type: "text", value: "" },
    billing_state: { type: "select", value: "" },
    billing_zipcode: { type: "text", value: "" },
    promo_code: { type: "text", value: promoCode },
    premise_type: { type: "text", value: "" },
    language: { type: "select", value: { label: "English", value: "english" } },
  });
  const [isSameBillingAddress, setIsSameBillingAddress] = useState(true);
  const [consentEmailMarketing, setConsentEmailMarketing] = useState(true);
  const [consentSmsMarketing, setConsentSmsMarketing] = useState(true);
  const [billingState, setBillingState] = useState<StatesOption | undefined>(
    undefined
  );
  const [reviewData, setReviewData] = useState<EnrollmentFields | undefined>(
    undefined
  );
  const [isAgree, setIsAgree] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorFields, setErrorFields] = useState<any>({});
  const [requiredFields, setRequiredFields] = useState<any>({
    last_name: { type: "text" },
    first_name: { type: "text" },
    email: { type: "email" },
    email2: { type: "email" },
    phone: { type: "number" },
    service_address: { type: "text" },
  });
  const [showSSN, setShowSSN] = useState(false);
  const promoCodeRef = useRef<null | HTMLDivElement>(null);
  const emailInputRef = useRef<null | HTMLDivElement>(null);

  const languageOptions = [
    { label: "English", value: "english" },
    { label: "Spanish", value: "spanish" },
  ];
  const [isAgreeCredit, setIsAgreeCredit] = useState(false);
  const [isAgreeLegal, setIsAgreeLegal] = useState(false);
  const [isAgreeDoc, setIsAgreeDoc] = useState(false);
  const [isAgreeContact, setIsAgreeContact] = useState(false);
  const [isAgreeRecord, setIsAgreeRecord] = useState(false);
  const [showConsentError, setShowConsentError] = useState<String[]>([]);
  const [serviceType, setServiceType] = useState<ServiceTypeOption | undefined>(
    undefined
  );
  const [startDate, setStartDate] = useState<undefined | Moment>(undefined);
  const [submitting, setSubmitting] = useState(false);
  const {
    holidays,
    getHolidays,
    // changeServiceAddress, changeUtility
  } = useContext<any>(EnrollmentContext);

  useEffect(() => {
    setTimeout(() => {
      const promoCodeError = localStorage.getItem("promoCodeError");
      // console.log(promoCodeError)
      if (promoCodeError) {
        setErrorFields({
          promoCode: "Invalid Promo Code",
        });
        localStorage.removeItem("promoCodeError");
      }
    }, 500);
  }, [show]);
  useEffect(() => {
    if (!show) return;
    window.digitalData.page.pageInfo.pageName = "Funnel Step 2";
  }, [show]);
  useEffect(() => {
    if (dynamicFields) {
      let newInputValue = Object.assign({}, inputValue),
        newRequiredFields: any = Object.assign({}, requiredFields);

      for (let cate in dynamicFields) {
        for (let key in dynamicFields[cate]) {
          const item = dynamicFields[cate][key];
          const { type } = item;
          if (key === "ssn") {
            newInputValue[key] = { type: "number", value: "" };
          } else {
            if (type === "checkbox") {
              newInputValue[key] = { type: type, value: false };
            } else if (type === "date" || type === "select") {
              newInputValue[key] = { type: type, value: undefined };
            } else {
              newInputValue[key] = { type: type, value: "" };
            }
          }
          if (key !== "premise_type") {
            newRequiredFields[key] = { type: type };
          }
        }
      }
      setInputValue(newInputValue);
      setRequiredFields(newRequiredFields);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dynamicFields]);
  const stepServiceValidate = () => {
    let isValid = true;
    let newErrorFields: any = {};
    if (!serviceType) {
      newErrorFields["serviceType"] = t("This field is required");
      isValid = false;
    }
    if (
      !startDate ||
      !(
        moment(startDate, "MM/DD/YYYY", true).isValid() ||
        moment(startDate, "M/DD/YYYY", true).isValid() ||
        moment(startDate, "MM/D/YYYY", true).isValid() ||
        moment(startDate, "M/D/YYYY", true).isValid()
      )
    ) {
      newErrorFields["startDate"] = t("Invalid Date");
      isValid = false;
    }

    if (holidays && startDate) {
      if (
        startDate.isBefore(moment(holidays.start, "YYYY-MM-DD")) ||
        startDate.isAfter(moment(holidays.end, "YYYY-MM-DD"))
      ) {
        newErrorFields["startDate"] = t("Invalid Date");
        isValid = false;
      }

      const blackoutDate = holidays?.blackout_dates?.filter(
        (val: string) =>
          val.indexOf(moment(startDate).format("YYYY-MM-DD")) >= 0
      );
      if (blackoutDate.length > 0) {
        newErrorFields["startDate"] = t("Invalid Date");
        isValid = false;
      }
    }

    setErrorFields(newErrorFields);
    return isValid;
  };

  const handleStepServiceSave = async () => {
    if (loading || !stepServiceValidate()) return;
    setLoading(true);

    let serviceTypeVal = "MoveIn",
      requestedDate = moment().add(1, "days").format("MM/DD/YYYY");
    if (serviceType && parseInt(serviceType.value) > 1) {
      serviceTypeVal = "Switching";
    }
    if (serviceType && parseInt(serviceType.value) < 3) {
      requestedDate = moment(startDate).format("MM/DD/YYYY");
    }
    const { esiid, street, zipcode, city, state } = serviceAddress[0];
    const saveFields = {
      esiid: esiid,
      service_address: street,
      service_zipcode: zipcode,
      service_city: city,
      service_state: state,
      service_type: serviceTypeVal,
      requested_date: requestedDate,
      product: product,
    };
    return saveEnrollment(null, saveFields, null).then((res) => {
      setLoading(false);

      if (res && parseInt(res.status) === 1 && res.response) {
        const { enrollment_id } = res.response;
        const { sign } = res.response;
        if (enrollment_id) {
          handleEnrollId(enrollment_id, sign);
          return {
            enrollmentId: enrollment_id,
            sign: sign,
          };
        } else {
          handleSetErrorModalContent({
            title: "Enrollment Id does not exist",
          });
          // toast.error('Enrollment Id does not exist')
        }
      } else {
        handleSetErrorModalContent({
          title: res.message,
        });
        // toast.error(res.message)
      }
    });
  };
  const validate = () => {
    let isValid = true;
    let newErrorFields: any = {};

    for (let i in requiredFields) {
      const { type } = requiredFields[i];

      if (i === "service_address") {
        const _address = localStorage.getItem("selectedAddress");
        if (!_address) {
          newErrorFields[i] = t("This field is required");
          isValid = false;
        }
        continue;
      }
      if (type === "checkbox") {
        continue;
      } else if (type === "date") {
        if (
          !inputValue[i].value ||
          !handleDateValidation(inputValue[i].value)
        ) {
          newErrorFields[i] = t("Invalid Date");
          isValid = false;
        }
      } else if (type === "email") {
        // eslint-disable-next-line
        const pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        if (!pattern.test(inputValue[i].value)) {
          newErrorFields[i] = t("Invalid emaill address format");
          isValid = false;
        }
      } else {
        if (!inputValue[i].value) {
          newErrorFields[i] = t("This field is required");
          isValid = false;
        }
      }
    }

    if (inputValue.phone.value.indexOf("_") >= 0) {
      newErrorFields["phone"] = t("Invalid Phone Number");
      isValid = false;
    }

    if (inputValue.ssn.value.indexOf("_") >= 0) {
      newErrorFields["ssn"] = t("Invalid SSN format");
      isValid = false;
    }

    if (inputValue.email.value && inputValue.email2.value) {
      if (inputValue.email.value.toLowerCase() !== inputValue.email2.value.toLowerCase()) {
        newErrorFields["email"] = t("Email address does not match");
        newErrorFields["email2"] = t("Email address does not match");
        isValid = false;
      }
    }

    if (!isSameBillingAddress && !billingState) {
      newErrorFields["billingState"] = t("This field is required");
      isValid = false;
    }

    if (!isAgree) {
      newErrorFields["isAgree"] = t("This field is required");
      isValid = false;
    }
    let newConsentError: String[] = [];
    if (!isAgreeRecord) {
      newConsentError.push("record");
      isValid = false;
    }

    setShowConsentError(newConsentError);
    setErrorFields(newErrorFields);
    return isValid;
  };

  const handleSave = async () => {
    if (loading || !validate()) return;

    setLoading(true);
    setSubmitting(true);
    let newErrorFields: any = {};

    let saveFields: any = {
      product: product,
    };

    const serviceAddr: any = {
      address: serviceAddress[0].street,
      state: serviceAddress[0].state,
      city: serviceAddress[0].city,
      zipcode: serviceAddress[0].zipcode,
    };

    let trueFields: any = {};
    const { enrollmentId, sign } = (await handleStepServiceSave()) || {
      enrollmentId: "",
      sign: "",
    };
    if (!enrollmentId) {
      return;
    }
    for (let i in inputValue) {
      if (i === "email2" || i === "billing_address2") continue;

      const item = inputValue[i];
      if (i.indexOf("billing_") >= 0) {
        const _key = i.substr(8);
        if (i === "billing_address") {
          const billingAddress = `${item.value} ${inputValue.billing_address2.value}`;
          saveFields[i] = isSameBillingAddress
            ? serviceAddr[_key]
            : billingAddress.trim();
        } else {
          saveFields[i] = isSameBillingAddress
            ? serviceAddr[_key]
            : inputValue[`billing_${_key}`].value;
        }
      } else {
        if (item.type === "number") {
          saveFields[i] = item.value ? item.value.replace(/ /g, "") : "";
        } else if (item.type === "date") {
          saveFields[i] = moment(item.value).format("MM/DD/YYYY");
        } else if (item.type === "select") {
          saveFields[i] = item.value ? item.value.value : "";
        } else {
          saveFields[i] = item.value;
        }
      }
    }

    for (const key in saveFields) {
      if (key === "ssn" || key === "date_of_birth") {
        specialPro[key] = saveFields[key];
      } else {
        trueFields[key] = saveFields[key];
      }
    }

    trueFields["premise_type"] =
      serviceAddress[0].unit === "" ? "House" : "Apartment";
    trueFields["email_marketing_consent"] = consentEmailMarketing;
    trueFields["product"] = product;
    trueFields["sms_marketing_consent"] = isAgreeContact;
    // trueFields['sms_marketing_consent'] = consentSmsMarketing;
    // storePromoCode(inputValue.promo_code.value);
    pushToDataLayer({
      event: "enrollment_credit_check",
      zip_code: utility.zipcode,
      user_region: serviceAddress[0].state,
      city : serviceAddress[0].city,
      provider:
        //@ts-ignore
        CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
        utility.utility_code,
      electricity_plan_rate: selectedProduct.price1000,
      electricity_plan_term: selectedProduct.contract_term,
      electricity_plan_name: selectedProduct.plan_name,
      electricity_plan_termination_fee: selectedProduct.cancel_fee,
      offer_code: localStorage.getItem("promoCode"),
      esiid: serviceAddress[0].esiid
    });

    saveEnrollment(enrollmentId, trueFields, sign).then((res) => {
      setLoading(false);
      if (res && parseInt(res.status) === 1) {
        // handleContinue(specialPro);
        handleSubmit(enrollmentId, specialPro, sign);
      } else {
        handleSetErrorModalContent({
          title: res.message,
        });
        // toast.error(res.message)
      }
    });
  };
  const location = useLocation();
  const navigate = useNavigate();
  const showServiceAddress = useMemo(() => {
    const fields = [
      "first_name",
      "last_name",
      "email",
      "email2",
      "phone",
      "date_of_birth",
    ];
    if (
      fields.every(
        (val) =>
          inputValue[val].value !== "" && inputValue[val].value !== undefined
      )
    ) {
      return true;
    }
    return false;
  }, [inputValue]);
  const [pushedToDL, setPushedToDL] = useState(false);
  useEffect(() => {
    if (showServiceAddress && !pushedToDL) {
      setPushedToDL(true);
      pushToDataLayer({
        event: "enrollment_contact_information",
        referrer_url: `${REFERER_URL}${location.search}`,
      });
    }
  }, [showServiceAddress]);

  const handleSubmit = (
    enrollmentId: string,
    specialPro: { ssn: any; date_of_birth: any },
    sign: string,
    utm_content = ""
  ) => {
    confirmEnrollment(
      enrollmentId,
      specialPro,
      sign,
      utm_content ? utm_content : ""
    ).then((res) => {
      if (res) {
        if (res.error_code) {
          navigate(`/v2/enrollment/failed${location.search}`);
        }
        if (res.error_code && res.error_code === "500") {
          setSubmitting(false);
          handleSetErrorModalContent({
            title:
              res.message || t("The enrollment request has been submitted"),
          });
          // toast.error(res.message || t('The enrollment request has been submitted'))
          return;
        }
        const { status } = res;
        if (status) {
          const errorCode = status.split(".")[0];
          switch (errorCode) {
            case "-1":
              pushToDataLayer({
                event: "enrollment_order_error",
                zip_code: serviceAddress[0].zipcode,
                user_region: serviceAddress[0].state,
                city: serviceAddress[0].city,
                provider:
                  //@ts-ignore
                  CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                  utility?.utility_code,
                electricity_plan_rate: selectedProduct.price1000,
                electricity_plan_term: selectedProduct.contract_term,
                electricity_plan_name: selectedProduct.plan_name,
                electricity_plan_termination_fee: selectedProduct.cancel_fee,
                offer_code: localStorage.getItem("promoCode"),
                confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
                esiid: serviceAddress[0].esiid,
                status: "Held/Rejected",
                error_message: res.message,
              });
              setSubmitting(false);
              handleSetErrorModalContent({
                title: res.message ? t(res.message) : t("An error occurred"),
              });
              break;
            case "0":
              pushToDataLayer({
                event: "enrollment_order_error",
                zip_code: serviceAddress[0].zipcode,
                user_region: serviceAddress[0].state,
                city: serviceAddress[0].city,
                provider:
                  //@ts-ignore
                  CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                  utility?.utility_code,
                electricity_plan_rate: selectedProduct.price1000,
                electricity_plan_term: selectedProduct.contract_term,
                electricity_plan_name: selectedProduct.plan_name,
                electricity_plan_termination_fee: selectedProduct.cancel_fee,
                offer_code: localStorage.getItem("promoCode"),
                confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
                esiid: serviceAddress[0].esiid,
                status: "Held/Rejected",
                error_message: res.message,
              });
              navigate(`/v2/enrollment/failed${location.search}`);
              setSubmitting(false);
              if (
                res.message &&
                (res.message.toLowerCase().indexOf("email_repeated") >= 0 ||
                  res.message.toLowerCase().indexOf("email_enrolled") >= 0)
              ) {
                handleSetErrorModalContent({
                  title: "Are you a current customer?",
                  desc: "It looks like you already have an account with us, please login to continue.",
                  button: "login",
                });
              } else {
                handleSetErrorModalContent({
                  title: t(res.message),
                });
              }
              // toast.error(t(res.message))
              if (res.message && res.message.indexOf("promoCode") >= 0) {
                handleBack();
                localStorage.setItem("promoCodeError", "1");
              }
              break;
            case "30":
              pushToDataLayer({
                event: "enrollment_order_error",
                zip_code: serviceAddress[0].zipcode,
                user_region: serviceAddress[0].state,
                city: serviceAddress[0].city,
                provider:
                  //@ts-ignore
                  CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                  utility?.utility_code,
                electricity_plan_rate: selectedProduct.price1000,
                electricity_plan_term: selectedProduct.contract_term,
                electricity_plan_name: selectedProduct.plan_name,
                electricity_plan_termination_fee: selectedProduct.cancel_fee,
                offer_code: localStorage.getItem("promoCode"),
                confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
                esiid: serviceAddress[0].esiid,
                status: "Held/Rejected",
                error_message: res.message,
              });
              navigate(`/v2/enrollment/failed${location.search}`);

              // } else {
              handleSSN(specialPro);
              handleContinue(res);
              handleSetName(
                `${
                  reviewData
                    ? `${reviewData.first_name} ${reviewData.last_name}`
                    : ""
                }`
              );
              // }
              break;
            case "20":
              pushToDataLayer({
                event: "enrollment_deposit_required",
                zip_code: serviceAddress[0].zipcode,
                user_region: serviceAddress[0].state,
                city: serviceAddress[0].city,
                provider:
                  //@ts-ignore
                  CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                  utility?.utility_code,
                electricity_plan_rate: selectedProduct.price1000,
                electricity_plan_term: selectedProduct.contract_term,
                electricity_plan_name: selectedProduct.plan_name,
                electricity_plan_termination_fee: selectedProduct.cancel_fee,
                offer_code: localStorage.getItem("promoCode"),
                confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
                esiid: serviceAddress[0].esiid,
                status: "Deposit"
              });
              localStorage.setItem("enrollmentResult", JSON.stringify(res));
              handlePayment(res);
              navigate(`/v2/enrollment/deposit${location.search}`);
              break;
            case "10":
              pushToDataLayer({
                event: "enrollment_order_complete",
                zip_code: serviceAddress[0].zipcode,
                user_region: serviceAddress[0].state,
                city: serviceAddress[0].city,
                provider:
                  //@ts-ignore
                  CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                  utility?.utility_code,
                electricity_plan_rate: selectedProduct.price1000,
                electricity_plan_term: selectedProduct.contract_term,
                electricity_plan_name: selectedProduct.plan_name,
                electricity_plan_termination_fee: selectedProduct.cancel_fee,
                offer_code: localStorage.getItem("promoCode"),
                confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
                esiid: serviceAddress[0].esiid,
                status: "Accepted"
              });
              navigate(`/v2/enrollment/success${location.search}`);
              handleSSN(specialPro);
              handleContinue(res);
              handleSetEmail(reviewData ? reviewData.email : "");
              handleSetName(
                `${
                  reviewData
                    ? `${reviewData.first_name} ${reviewData.last_name}`
                    : ""
                }`
              );
              break;
            case "40":
            case "50":
              pushToDataLayer({
                event: "enrollment_order_error",
                zip_code: serviceAddress[0].zipcode,
                user_region: serviceAddress[0].state,
                city: serviceAddress[0].city,
                provider:
                  //@ts-ignore
                  CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
                  utility?.utility_code,
                electricity_plan_rate: selectedProduct.price1000,
                electricity_plan_term: selectedProduct.contract_term,
                electricity_plan_name: selectedProduct.plan_name,
                Cancellation_fee: selectedProduct.cancel_fee,
                offer_code: localStorage.getItem("promoCode"),
                confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
                esiid: serviceAddress[0].esiid,
                status: "Held/Rejected",
                error_message: res.message,
              });
              navigate(`/v2/enrollment/failed${location.search}`);
              handleSSN(specialPro);
              handleContinue(res);
              handleSetName(
                `${
                  reviewData
                    ? `${reviewData.first_name} ${reviewData.last_name}`
                    : ""
                }`
              );
              break;
            default:
          }
        }
      } else {
        pushToDataLayer({
          event: "enrollment_order_error",
          zip_code: serviceAddress[0].zipcode,
          user_region: serviceAddress[0].state,
          city: serviceAddress[0].city,
          provider:
            //@ts-ignore
            CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
            utility?.utility_code,
          electricity_plan_rate: selectedProduct.price1000,
          electricity_plan_term: selectedProduct.contract_term,
          electricity_plan_name: selectedProduct.plan_name,
          electricity_plan_termination_fee: selectedProduct.cancel_fee,
          offer_code: localStorage.getItem("promoCode"),
          confirmation_number: res.additional ? res.additional[0]?.customer_id : "",
          esiid: serviceAddress[0].esiid,
          status: "Held/Rejected",
          error_message: res.message,
        });
        navigate(`/v2/enrollment/failed${location.search}`);
        setSubmitting(false);
        handleSetErrorModalContent({
          title: t("An error occurred"),
        });
        // toast.error(t('An error occurred'))
      }
    });
  };

  const handleChangeInput = (evt: any) => {
    const { value, name } = evt.target;

    let newInputValue = Object.assign({}, inputValue);
    newInputValue[name as any].value = value;
    setInputValue(newInputValue);

    if (name === "email") {
      let newErrorFields: any = errorFields;
      if (inputValue.email2.value && value !== inputValue.email2.value) {
        newErrorFields["email"] = t("Email address does not match");
      }else {
        newErrorFields["email"] = "";
      }
      setErrorFields(newErrorFields);
    }

    if (name === "email2") {
      let newErrorFields: any = errorFields;
      if ( value !== inputValue.email.value) {
        newErrorFields["email2"] = t("Email address does not match");
      }else {
        newErrorFields["email2"] = "";
      }
      setErrorFields(newErrorFields);
    }
  };

  const handleDateValidation = (inputDate: string) => {
    // Assuming inputDate is in MM/DD/YYYY format
    let parts = inputDate.split("/");
    let month = parseInt(parts[0], 10);
    let day = parseInt(parts[1], 10);
    let year = parseInt(parts[2], 10);

    // Validate the date format and range
    if (
      !isNaN(month) &&
      !isNaN(day) &&
      !isNaN(year) &&
      month >= 1 &&
      month <= 12 &&
      day >= 1 &&
      day <= 31 &&
      year >= new Date().getFullYear() - 100 &&
      year <= new Date().getFullYear()
    ) {
      // Date is valid
      const { date_of_birth, ...errorField } = errorFields;
      setErrorFields(errorField);
      return true;
    } else {
      // Date is invalid
      setErrorFields((preProcessFiles: any) => ({
        ...preProcessFiles,
        date_of_birth: "Invalid date"
      }))
      return false;
    }
  };

  const getDynamicFields = (type: string) => {
    const group = dynamicFields[type];

    return (
      <EnrollmentFormRow>
        {Object.keys(group).map((val, idx) => {
          const item = group[val];
          const { label, type } = item;
          if (type === "checkbox") {
            return (
              <EnrollmentFormCol key={idx}>
                <CheckboxItem
                  label={t(label)}
                  value={`${inputValue[val].value}`}
                  checked={inputValue[val].value}
                  handleClick={() => {
                    let newInputValue = Object.assign({}, inputValue);
                    newInputValue[val].value = !newInputValue[val].value;
                    setInputValue(newInputValue);
                  }}
                  onlyread={false}
                  disabled={loading}
                  id={label}
                />
              </EnrollmentFormCol>
            );
          } else if (type === "select") {
            if (val === "premise_type") return null;
            return (
              <EnrollmentFormCol key={idx}>
                <Form.Group className={errorFields[val] ? "error" : ""}>
                  <Form.Label>{t(label)} *</Form.Label>
                  <Dropdown className="plans-filter-dd">
                    <Dropdown.Toggle
                      disabled={loading}
                      variant="outline-secondary"
                    >
                      {inputValue[val] && inputValue[val].value
                        ? t(inputValue[val].value.label)
                        : `${t("Please Select")}...`}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {(item.value as Object[]).map(
                        (option: any, optionIdx) => {
                          return (
                            <Dropdown.Item
                              eventKey={option.label}
                              key={optionIdx}
                              onClick={() => {
                                let newInputValue = Object.assign(
                                  {},
                                  inputValue
                                );
                                newInputValue[val].value = option;
                                setInputValue(newInputValue);
                              }}
                              active={
                                inputValue[val].value &&
                                inputValue[val].value.value === option.value
                              }
                            >
                              {t(option.label)}
                            </Dropdown.Item>
                          );
                        }
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
                <FormError message={errorFields[val]} />
              </EnrollmentFormCol>
            );
          } else if (type === "date") {
            return (
              <EnrollmentFormCol key={idx}>
                <Form.Group className={errorFields[val] ? "error" : ""}>
                  <Form.Label>{t(label)} *</Form.Label>
                  <NumberFormat
                    format="##/##/####"
                    mask="_"
                    name="date"
                    value={inputValue[val] ? inputValue[val].value : undefined}
                    onChange={(e: any) => {
                      let date = e.target.value;
                      let newInputValue = Object.assign({}, inputValue);
                      newInputValue[val].value = date;
                      setInputValue(newInputValue);
                    }}
                    className="form-control"
                    disabled={loading}
                    onBlur={(e: any) => {
                      handleDateValidation(e.target.value);
                    }}
                  />
                  {/* <Datetime
                                        value={inputValue[val] ? inputValue[val].value : undefined}
                                        onChange={(date: any) => {
                                            let newInputValue = Object.assign({}, inputValue)
                                            newInputValue[val].value = date
                                            setInputValue(newInputValue)
                                        }}
                                        initialViewDate={moment().subtract(30, 'years')}
                                        dateFormat="MM/DD/YYYY"
                                        timeFormat={false}
                                        closeOnSelect={true}
                                        isValidDate={(currentDate) => {
                                            if (currentDate.isAfter(moment())) return false
                                            return true
                                        }}
                                        inputProps={{
                                            placeholder: t('MM/DD/YYYY'),
                                            disabled: loading,
                                        }}
                                    /> */}
                </Form.Group>
                <FormError message={errorFields[val]} />
              </EnrollmentFormCol>
            );
          } else {
            if (val === "ssn" && inputValue[val]) {
              return (
                <EnrollmentFormCol key={idx}>
                  <InputWithMask>
                    <Form.Group className={errorFields[val] ? "error" : ""}>
                      <Form.Label>{t("SSN")} *</Form.Label>
                      <NumberFormat
                        format="### ## ####"
                        mask="_"
                        name={val}
                        value={inputValue[val].value}
                        onChange={handleChangeInput}
                        className="form-control"
                        disabled={loading}
                      />
                      {!showSSN && (
                        <NumberFormat
                          type="password"
                          maxLength={9}
                          name={val}
                          value={inputValue[val].value}
                          onChange={handleChangeInput}
                          className="form-control mask-input"
                          disabled={loading}
                        />
                      )}
                    </Form.Group>
                    <InputMaskToggle
                      type="button"
                      active={showSSN}
                      onClick={() => setShowSSN(!showSSN)}
                    />
                  </InputWithMask>
                  <FormError message={errorFields[val]} />
                </EnrollmentFormCol>
              );
            }
            return (
              <EnrollmentFormCol key={"stepInfo"}>
                <Form.Group className={errorFields[val] ? "error" : ""}>
                  <Form.Label>{t(label)} *</Form.Label>
                  <Form.Control
                    type="text"
                    name={val}
                    placeholder=""
                    maxLength={50}
                    value={inputValue[val] ? inputValue[val].value : undefined}
                    onChange={handleChangeInput}
                    disabled={loading}
                  />
                </Form.Group>
                <FormError message={errorFields[val]} />
              </EnrollmentFormCol>
            );
          }
        })}
      </EnrollmentFormRow>
    );
  };

  if (!show) return null;
  if (!dynamicFields) {
    return (
      <div className="d-flex justify-content-center pt-5 pb-5">
        <LoadingRow />
      </div>
    );
  }

  return (
    <EnrollmentStepWrapper>
      {/* <h6 className="mt-2">Service Address *</h6>
      {serviceAddress && <h5 className="mt-2">{serviceAddress[0]?.label}</h5>} */}
      <Form>
        <EnrollmentFormRow>
          <EnrollmentFormCol>
            <Form.Group className={errorFields["first_name"] ? "error" : ""}>
              <Form.Label>{t("First Name")} *</Form.Label>
              <Form.Control
                type="text"
                name="first_name"
                maxLength={50}
                value={inputValue.first_name.value}
                onChange={handleChangeInput}
                disabled={loading}
              />
            </Form.Group>
            <FormError message={errorFields["first_name"]} />
          </EnrollmentFormCol>
          <EnrollmentFormCol>
            <Form.Group className={errorFields["last_name"] ? "error" : ""}>
              <Form.Label>{t("Last Name")} *</Form.Label>
              <Form.Control
                type="text"
                name="last_name"
                maxLength={50}
                value={inputValue.last_name.value}
                onChange={handleChangeInput}
                disabled={loading}
              />
            </Form.Group>
            <FormError message={errorFields["last_name"]} />
          </EnrollmentFormCol>
          <EnrollmentFormCol ref={emailInputRef}>
            <Form.Group className={errorFields["email"] ? "error" : ""}>
              <Form.Label>{t("Email")} *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder=""
                maxLength={150}
                value={inputValue.email.value}
                onChange={handleChangeInput}
                disabled={loading}
              />
            </Form.Group>
            <FormError message={errorFields["email"]} />
          </EnrollmentFormCol>
          <EnrollmentFormCol>
            <Form.Group className={errorFields["email2"] ? "error" : ""}>
              <Form.Label>{t("Confirm Email")} *</Form.Label>
              <Form.Control
                type="email"
                name="email2"
                placeholder=""
                maxLength={150}
                value={inputValue.email2.value}
                onChange={handleChangeInput}
                disabled={loading}
              />
            </Form.Group>
            <FormError message={errorFields["email2"]} />
          </EnrollmentFormCol>
          <EnrollmentFormCol>
            <Form.Group className={errorFields["phone"] ? "error" : ""}>
              <Form.Label>{t("Phone Number")} *</Form.Label>
              <NumberFormat
                format="### ### ####"
                mask="_"
                name="phone"
                value={inputValue.phone.value}
                onChange={handleChangeInput}
                className="form-control"
                disabled={loading}
              />
            </Form.Group>
            <FormError message={errorFields["phone"]} />
          </EnrollmentFormCol>
        </EnrollmentFormRow>

        {getDynamicFields("ext_input")}
        <div>
          {showServiceAddress && (
            <>
              <EnrollmentStepService
                billingState={billingState}
                handleChangeInput={handleChangeInput}
                inputValue={inputValue}
                isSameBillingAddress={isSameBillingAddress}
                requiredFields={requiredFields}
                setBillingState={setBillingState}
                setInputValue={setInputValue}
                setIsSameBillingAddress={setIsSameBillingAddress}
                setRequiredFields={setRequiredFields}
                show={show}
                startDate={startDate}
                serviceType={serviceType}
                setServiceType={setServiceType}
                setStartDate={setStartDate}
                errorFields={errorFields}
              />
              <CreditCheckSection>
                <h5>{t("Utility Credit Check")}</h5>
                <p>
                  {t(
                    "A utility soft credit check is necessary to assess whether a deposit will be required. lt does not affect your credit score. Your information is securely transmitted over an encrypted connection to Constellation Energy, a Texas Retail Energy Provider, which requirespersonal identification information to review and process your enrollment. Constellation.com does not store, use, or sell any personal information collected."
                  )}
                </p>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="flex-fill">
                    {getDynamicFields("credit_check")}
                  </div>
                </div>
              </CreditCheckSection>
              <EnrollmentFormRow>
                <EnrollmentFormCol full>
                  <div
                    className="checkbox-row"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <CheckboxItem
                      label=""
                      value={`${isAgree}`}
                      checked={isAgree}
                      handleClick={() => {
                        setIsAgree(!isAgree);
                      }}
                      onlyread={false}
                      disabled={loading}
                      id="is-agree-tos"
                      error={errorFields["isAgree"]}
                      renderLabel={() => (
                        <>
                          <span>
                            {t(
                              "I hereby authorize Constellation.com to run a credit check and perform all necessary tasks to establish electricity service. I accept the terms and conditions of the Constellation.com."
                            )}
                          </span>
                        </>
                      )}
                    />
                    {/* <FormError message={errorFields["isAgree"]} /> */}
                  </div>
                </EnrollmentFormCol>
              </EnrollmentFormRow>
              <EnrollmentFormRow>
                <EnrollmentFormCol full>
                  <div className="checkbox-row">
                    <p style={{ fontSize: "1.1rem" }}>
                      Check the box(es) on the left to agree to the terms below:
                    </p>
                    <CheckboxItem
                      // eslint-disable-next-line react/jsx-key
                      label=""
                      value={`${isAgreeRecord}`}
                      checked={isAgreeRecord}
                      handleClick={() => {
                        let [...newShowConsentError] = showConsentError;
                        const pos = showConsentError.indexOf("record");
                        if (pos >= 0) {
                          newShowConsentError.splice(pos, 1);
                          setShowConsentError(newShowConsentError);
                        }
                        setIsAgreeRecord(!isAgreeRecord);
                      }}
                      onlyread={false}
                      disabled={loading}
                      error={showConsentError.indexOf("record") >= 0}
                      renderLabel={() => (
                        <>
                          <span>
                            I consent to the use of electronic records and
                            signatures including the provision of state and
                            federal disclosures in place of written
                            documentation and handwritten signatures in
                            connection with my enrollment application.
                          </span>
                          <span style={{ marginTop: "20px" }}>
                            I authorize Constellation to share my customer
                            information with its affiliates and its and their
                            third party providers, provided that each such
                            recipient agrees to hold such information in
                            confidence.
                          </span>
                          <span style={{ marginTop: "20px" }}>
                            I agree on behalf of myself, the applicant, that I
                            am demonstrating the ability to access and view all
                            enrollment information in the electronic formats
                            disclosed above and agree to print and keep a copy
                            of this enrollment for my records.
                          </span>
                        </>
                      )}
                    />
                  </div>
                  <div className="checkbox-row">
                    <p style={{ fontSize: "1.1rem" }}>
                      Check the box below to opt in to receiving SMS
                      notifications from Constellation about your Electricity
                      order.
                    </p>
                    <CheckboxItem
                      label=""
                      value={`${isAgreeContact}`}
                      checked={isAgreeContact}
                      handleClick={() => {
                        let [...newShowConsentError] = showConsentError;
                        const pos = showConsentError.indexOf("contact");
                        if (pos >= 0) {
                          newShowConsentError.splice(pos, 1);
                          setShowConsentError(newShowConsentError);
                        }
                        setIsAgreeContact(!isAgreeContact);
                      }}
                      onlyread={false}
                      disabled={loading}
                      error={showConsentError.indexOf("contact") >= 0}
                      renderLabel={() => (
                        <>
                          {/* <span>
                            I would like to receive text messages about my
                            Electricity order, order status, and related offers
                            at the number entered above, including identity
                            verification.
                          </span> */}
                          <span>
                          By checking this box, I agree to receive recurring automated marketing text messages and automated/prerecorded marketing calls from Constellation to the phone number provided in this form. I understand that providing consent is not a condition of completing this transaction.
                            {/* I hereby consent to receive autodialed and/or pre-recorded telemarketing calls and/or text messages from or on behalf of Constellation at the telephone number listed above. I understand that this consent is not a condition of purchasing any goods or services from Constellation. */}
                          </span>
                        </>
                      )}
                    />
                  </div>
                </EnrollmentFormCol>
              </EnrollmentFormRow>
              <EnrollmentStepFooter>
                <Button
                  secondary
                  disabled={loading}
                  type="button"
                  onClick={() => handleBack()}
                >
                  {t("Back")}
                </Button>
                <Button
                  type="button"
                  onClick={() => handleSave()}
                  data-test-id="cta"
                >
                  <span>{t("Submit")}</span>
                  {loading && (
                    <Spinner
                      animation="border"
                      variant="light"
                      size="sm"
                      className="ms-2"
                    />
                  )}
                </Button>
              </EnrollmentStepFooter>{" "}
            </>
          )}
        </div>

        <FormLoading
          show={submitting}
          content={t("This process may take up to 1 minute", { ns: "common" })}
        />
      </Form>
    </EnrollmentStepWrapper>
  );
};
